import { useState, useCallback } from 'react';
import type { Tramite } from '@/types';

export interface UseTramiteStatusDialogReturn {
  isOpen: boolean;
  selectedTramite: Tramite | null;
  openDialog: (tramite: Tramite) => void;
  closeDialog: () => void;
}

export function useTramiteStatusDialog(): UseTramiteStatusDialogReturn {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTramite, setSelectedTramite] = useState<Tramite | null>(null);

  const openDialog = useCallback((tramite: Tramite) => {
    setSelectedTramite(tramite);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setSelectedTramite(null);
  }, []);

  return {
    isOpen,
    selectedTramite,
    openDialog,
    closeDialog,
  };
}

export default useTramiteStatusDialog;